import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Trans, useTranslation } from 'react-i18next';

import ECNYWarningImg from '@/assets/ecny-warning.png';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const ECNYWarningModal = NiceModal.create(({ amount }: { amount: number }) => {
  const modal = useModal('ecny-warning-modal');
  const { t } = useTranslation();

  const handleClose = () => {
    modal.hide();
    setTimeout(() => {
      modal.remove();
    }, 100);
  };

  return (
    <Dialog open={modal.visible}>
      <DialogContent className="w-[90%] max-w-[320px]">
        <DialogHeader>
          <DialogTitle className="text-center text-base py-1 font-medium">
            <div className="leading-[1.5] whitespace-break-spaces">
              <Trans
                i18nKey="ecny_warning_dialog_title"
                components={{ red: <span className="text-caution font-semibold" /> }}
                values={{ amount }}
              />
            </div>
          </DialogTitle>
        </DialogHeader>
        <div className="max-h-[330px]">
          <img src={ECNYWarningImg} alt="ecny warning" />
        </div>
        <DialogFooter className="flex">
          <Button className="flex-1" onClick={handleClose}>
            {t('acknowledge')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

export default ECNYWarningModal;
